import { createApp } from 'vue'
import SimpleCard from './SimpleCard'

const el = '.kb-component--simple-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((SimpleCardDOM) => {
            const result = JSON.parse(SimpleCardDOM.dataset.result)
            const component = createApp(SimpleCard, { result }).use(Store)
            component.mount(SimpleCardDOM)
        })
    }
}
